import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { patchUpdateOrganizationTilaajavastuuFetchActive } from '../services/patchUpdateOrganizationTilaajavastuuFetchActive.service';

export const updateOrganizationTilaajavastuuFetchActive = createAsyncThunk(
  'organizationCharts/updateOrganizationTilaajavastuuFetchActive',
  async (
    { organizationChartItemId, isTilaajavastuuDocumentsFetchActive },
    { getState }
  ) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await patchUpdateOrganizationTilaajavastuuFetchActive(
      selectedProjectId,
      organizationChartItemId,
      isTilaajavastuuDocumentsFetchActive
    );

    return response;
  }
);
